import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { SiteContentProvider } from "@/SiteContentContext";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <SiteContentProvider>
        <App />
      </SiteContentProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
